import { Component, Input, OnInit } from '@angular/core';
import { DrupalService } from 'src/app/services/drupal.service';

@Component({
  selector: 'app-faq-loader',
  templateUrl: './faq_loader.component.html',
  styleUrls: ['./faq_loader.component.scss']
})
export class FaqLoaderComponent implements OnInit {

  constructor(private drupalService: DrupalService) { }
  faqList: any[] = [];
  faqNumber: number = 0;
  limit: number = 0;
  searchTerm: string = '';
  hasMore: boolean = true;


  ngOnInit(): void {
    this.data.faq_loader_faqs = Array.isArray(this.data.faq_loader_faqs) ? this.data.faq_loader_faqs.filter((faq: any) => faq.status === true) : [];
    this.loadFAQList(this.data.faq_loader_limit);
  }

  @Input() data: any;

  loadFAQList(limit: number): void {
    const startIndex = this.faqList.length;
    const endIndex = Number(startIndex) + Number(limit);

    if (endIndex > this.data.faq_loader_faqs.length) {
      this.faqList = this.faqList.concat(this.data.faq_loader_faqs.slice(startIndex));
      this.hasMore = false;
    } else {
      this.faqList = this.faqList.concat(this.data.faq_loader_faqs.slice(startIndex, endIndex));
    }

    this.faqNumber = this.faqList.length;
  }

  loadMore(): void {
    if (this.hasMore) {
      this.loadFAQList(this.data.faq_loader_limit);
    }
  }

  onEnterPressed(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search(this.searchTerm);
    }
  }

  search(term: string) {
    if (term === '') {
      this.faqList = [];
      this.faqList = this.faqList.concat(this.data.faq_loader_faqs.slice(0, this.data.faq_loader_limit));
      if (this.faqList.length < this.data.faq_loader_faqs.length) {
        this.hasMore = true;
      }
    } else {
      // Perform a search with HttpClient
      this.drupalService.ESQuerySearch('faq', {
        "query": {
          "bool": {
            "must": [
              {
                "multi_match": {
                  "query": term,
                  "type": "phrase_prefix",
                  "fields": ["data.title", "data.faq_body.processed"]
                }
              }
            ]
          }
        }
      }
      ).subscribe({
        next: (data: any) => {
          this.faqList = data.hits.hits.map((item: any) => item.data);
          this.hasMore = false;
        },
        error: console.error
      });
    }
  }
}




